import { PayloadAction } from '@reduxjs/toolkit';
import { capitalizeFirstLetter } from 'utils/capitalize-first-letter';

export const makePropertyReducer =
  <TState extends Record<string, unknown>>() =>
  <TName extends Extract<keyof TState, string>>(name: TName) =>
    ({
      [`set${capitalizeFirstLetter(name)}`]: (
        state: TState,
        action: PayloadAction<TState[TName]>,
      ) => {
        state[name] = action.payload;
      },
    }) as Record<
      `set${Capitalize<TName>}`,
      (state: TState, action: PayloadAction<TState[TName]>) => void
    >;
